import script from "./TooltipColors.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipColors.vue?vue&type=script&setup=true&lang=js"

import "./TooltipColors.vue?vue&type=style&index=0&id=933f4458&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-933f4458"]])

export default __exports__